.chart {
  display: block;
  width: 100%;
  height: auto;
  min-width: 0;
  overflow: visible;
  color: var(--text-subtle);
  font-family: var(--font-body);
  font-size: var(--fs-3xs);
  font-variant-numeric: tabular-nums;
}

.grid {
  stroke: var(--border-hair);
  stroke-width: var(--bw-hair);
  vector-effect: non-scaling-stroke;
}

.axisLabel {
  fill: var(--text-subtle);
}

.series {
  color: var(--accent-500);
}

.series[data-color="accent-2"] {
  color: var(--cyan-600);
}

.series[data-color="muted"] {
  color: var(--gray-400);
}

.line {
  fill: none;
  stroke: currentColor;
  stroke-width: var(--bw-thick);
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}

.area {
  fill: currentColor;
  opacity: 0.12;
}

.point {
  fill: var(--surface-card);
  stroke: currentColor;
  stroke-width: var(--bw-thick);
  vector-effect: non-scaling-stroke;
}

.bar {
  fill: currentColor;
}

.estado {
  display: flex;
  min-height: var(--s-15);
  flex-direction: column;
  justify-content: center;
  gap: var(--s-6);
  padding: var(--s-8);
  border: var(--bw-hair) dashed var(--border-strong);
  border-radius: var(--r-lg);
  color: var(--text-muted);
  text-align: center;
}

@media (prefers-reduced-motion: reduce) {
  .chart * {
    transition: none;
  }
}
